"use client";
import { jsx as l, jsxs as A } from "react/jsx-runtime";
import * as o from "@radix-ui/react-alert-dialog";
import { forwardRef as e, isValidElement as n } from "react";
import { Text as d } from "../Text/Text.mjs";
const x = (t) => /* @__PURE__ */ l(o.Root, { "data-slot": "alert-dialog", ...t }), D = e((t, a) => /* @__PURE__ */ l(o.Trigger, { "data-slot": "alert-dialog-trigger", ...t, ref: a }));
D.displayName = "AlertDialogTrigger";
const m = (t) => /* @__PURE__ */ l(o.Portal, { "data-slot": "alert-dialog-portal", ...t }), c = e((t, a) => /* @__PURE__ */ l(o.Overlay, { "data-slot": "alert-dialog-overlay", ...t, ref: a }));
c.displayName = "AlertDialogOverlay";
const p = e((t, a) => /* @__PURE__ */ A(m, { children: [
  /* @__PURE__ */ l(c, {}),
  /* @__PURE__ */ l(o.Content, { "data-slot": "alert-dialog-content", ...t, ref: a })
] }));
p.displayName = "AlertDialogContent";
const y = e(
  ({ children: t, fontSize: a = "lg", fontWeight: i = "semibold", fontFamily: r = "inter", ...s }, g) => /* @__PURE__ */ l(o.Title, { "data-slot": "alert-dialog-title", ...s, ref: g, children: /* @__PURE__ */ l(d, { asChild: !0, fontSize: a, fontWeight: i, fontFamily: r, children: n(t) ? t : /* @__PURE__ */ l("span", { children: t }) }) })
);
y.displayName = "AlertDialogTitle";
const C = e(
  ({ children: t, fontSize: a = "sm", fontWeight: i = "regular", fontFamily: r = "inter", ...s }, g) => /* @__PURE__ */ l(o.Description, { "data-slot": "alert-dialog-description", ...s, ref: g, children: /* @__PURE__ */ l(d, { asChild: !0, fontSize: a, fontWeight: i, fontFamily: r, children: n(t) ? t : /* @__PURE__ */ l("span", { children: t }) }) })
);
C.displayName = "AlertDialogDescription";
const N = e((t, a) => /* @__PURE__ */ l(o.Action, { "data-slot": "alert-dialog-action", ...t, ref: a }));
N.displayName = "AlertDialogAction";
const T = e((t, a) => /* @__PURE__ */ l(o.Cancel, { "data-slot": "alert-dialog-cancel", ...t, ref: a }));
T.displayName = "AlertDialogCancel";
export {
  N as AlertDialogAction,
  T as AlertDialogCancel,
  p as AlertDialogContent,
  C as AlertDialogDescription,
  c as AlertDialogOverlay,
  m as AlertDialogPortal,
  x as AlertDialogRoot,
  y as AlertDialogTitle,
  D as AlertDialogTrigger
};
